<template>
    <div class="card card-dashboard-thirteen mg-t-20" style="width:100%" v-loading='loading'>
        <label class="az-content-label">Tax Returns Outstanding </label>
        <div class="row mg-t-20 mg-b-20">
            <p class="d-block mg-b-20 az-content-text pd-15">There is <strong style="color:black">{{outstanding.length}}</strong>{{outstanding.length>1?' funds ':' fund '}}with {{ previousYear }} (or prior year) tax returns outstanding.</p>
            <div class="table-responsive">
                <table class="table table-striped table-dashboard-two">
                <thead>
                    <tr>
                    <th class="wd-lg-50p">Fund Name</th>
                    </tr>
                </thead>
                <tbody >
                <tr v-for="(item,index) in outstanding" :key="index">
                    <td class="tx-medium">
                    <router-link :to="{path:'/funddashboard/'+item[0],query:{name:item[1]}}">{{isSample?'Sample Family Super Fund '+(index+1):item[1]}} </router-link>
                    </td>
                </tr>
                </tbody>
                </table>
            </div><!-- table-responsive -->
        </div>
    </div>
</template>
<script>
export default {
    name:'taxoutstanding',
    components: { 

    },
    data(){
        return{
            isSample:false,
            brand:'',
            outstanding:[],
            loading:true,
            previousYear: new Date().getFullYear() - 1
        }
    },
    created(){
        this.getOutstanding();
    },
    methods:{
        getOutstanding: function(){
           
            const userdetail = JSON.parse(localStorage.getItem('userdetail'));
            let brand = localStorage.getItem('brand_code')
            this.isSample = userdetail['sample']
            this.$api.adviserdashboard_api.tax_outstanding(brand).then(response =>{
                this.outstanding = response.data['tax_outstanding_funds']
                this.loading=false
            });
        
        },
        
        
    }
}
</script>